<template>
    <div v-if="pages" class="ui-pagination">
        <div class="text">
            Página {{ current }} de {{ pages }}
        </div>
        <div class="control">
            <button class="button" type="button" :disabled="Number(current) <= 1" @click="previousPage">
                <i class="fal fa-angle-left"></i>
            </button>
            <button class="button" type="button" :disabled="Number(current) >= Number(pages)" @click="nextPage">
                <i class="fal fa-angle-right"></i>
            </button>
        </div>
    </div>
    <div v-else class="ui-pagination">
        <div class="text">
            Página {{ current }}
        </div>
        <div class="control">
            <button class="button" type="button" :disabled="(current == 1)" @click="previousPage">
                <i class="fal fa-angle-left"></i>
            </button>
            <button class="button" type="button" :disabled="!next" @click="nextPage">
                <i class="fal fa-angle-right"></i>
            </button>
        </div>
    </div>
</template>

<script>

	export default {
		props: {
            pages: {
                type: [String, Number],
                required: false
            },
            current: {
                type: [String, Number],
                required: true
            },
            //Páginação facebook
            next: {
                type: Boolean,
                required: false
            }
		},

		data() {
			return {
                component: null,
            }
        },

		methods: {
            nextPage() {
                this.$emit('next')
            },

            previousPage() {
                this.$emit('previous')
            },
        }
	}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>